(function () {

    function initCMTestimonials() {

        if (typeof Swiper === "undefined") return;

        document.querySelectorAll(".cm-testimonials-slider").forEach(function (slider) {

            if (slider.swiper) {
                slider.swiper.destroy(true, true);
            }

            new Swiper(slider, {

                slidesPerView:1,
                spaceBetween:20,
                speed:700,
                loop:true,

                autoplay:{
                    delay:4000,
                    disableOnInteraction:false
                },

                pagination:{
                    el:slider.querySelector(".swiper-pagination"),
                    clickable:true
                },

                navigation:{
                    nextEl:slider.querySelector(".swiper-button-next"),
                    prevEl:slider.querySelector(".swiper-button-prev")
                },

                breakpoints:{
                    768:{
                        slidesPerView:2,
                        spaceBetween:24
                    },
                    1200:{
                        slidesPerView:3,
                        spaceBetween:30
                    }
                }

            });

        });

    }

    document.addEventListener("DOMContentLoaded", initCMTestimonials);

    document.addEventListener("shopify:section:load", initCMTestimonials);

    document.addEventListener("shopify:section:reorder", initCMTestimonials);

})();